// Utilitário centralizado para construção de URLs de imagens
// Evita duplicação de código e garante consistência em todo o sistema

export const getImageUrl = (midiaUrl: string): string => {
  if (!midiaUrl) return '';

  // Determinar a base da API a partir das envs
  const rawBackend = (process.env.REACT_APP_BACKEND_URL || '').replace(/\/+$/, '') || 'http://localhost:3005';
  const rawApiBaseEnv = (process.env.REACT_APP_API_BASE_URL || '').replace(/\/+$/, '');
  const apiBase = rawApiBaseEnv || (rawBackend.endsWith('/api') ? rawBackend : `${rawBackend}/api`);

  // Extrair origin da base da API
  let origin = '';
  try {
    const u = new URL(apiBase);
    origin = u.origin;
  } catch {
    origin = rawBackend;
  }

  // Normalizar caminho de mídia para sempre usar /api/uploads/
  const rawPath = midiaUrl.startsWith('/') ? midiaUrl : `/${midiaUrl}`;
  const idx = rawPath.toLowerCase().indexOf('/uploads');
  const uploadsPath = idx >= 0 ? rawPath.substring(idx) : rawPath;
  
  // Construir URL usando sempre /api/uploads/ (caminho correto)
  const finalUrl = `${origin}/api${uploadsPath}`;
  
  return finalUrl;
};

// Função para tratamento de erro de imagem com fallback
export const handleImageError = (e: React.SyntheticEvent<HTMLImageElement, Event>, fallbackSrc: string = '/placeholder-property.jpg') => {
  const img = e.target as HTMLImageElement;
  
  // Verificar se já está usando fallback ou imagem padrão
  const currentSrc = img.src;
  const isAlreadyFallback = currentSrc.includes('/api/uploads/') || currentSrc.startsWith('data:') || currentSrc.includes('placeholder');
  
  // Se já está usando fallback ou imagem padrão, não fazer nada para evitar loop
  if (isAlreadyFallback) {
    console.log('🔄 Imagem já está usando fallback, não tentando novamente');
    return;
  }
  
  // Verificar se já tentou fallback usando dataset
  const tried = (img as any).dataset?.altTried === '1';
  if (tried) {
    console.log('🔄 Fallback já foi tentado, usando placeholder');
    img.src = fallbackSrc;
    return;
  }
  
  // Marcar como tentado ANTES de fazer qualquer mudança
  (img as any).dataset.altTried = '1';
  
  if (currentSrc.includes('/api/uploads/')) {
    // Tentar com rota alternativa /uploads/ se a rota principal /api/uploads/ falhar (CORS ou 503)
    const fallbackUrl = currentSrc.replace('/api/uploads/', '/uploads/');
    console.log('🔄 Tentando fallback de CORS/503:', {
      original: currentSrc,
      fallback: fallbackUrl
    });
    img.src = fallbackUrl;
  } else {
    console.log('🔄 Usando placeholder padrão');
    img.src = fallbackSrc;
  }
};
